import EditOrderPage from './EditOrderPage';

export default EditOrderPage;
